import GenericUploadError from '../GenericUploadError';

export default class LargeFileUploadError extends GenericUploadError {}
